import React from "react";

import { Row } from "react-bootstrap";
import { ConclusaoObra } from "../../../../shared/interfaces/IProperties";
import { DivisorPeB } from "../divisor";

interface ZoneamentoProps {
    cvcos?: ConclusaoObra[];
}

export const AraucariaCvco: React.FC<ZoneamentoProps> = ({ cvcos }) => {
    return (
        <>
            <Row>
                {cvcos && cvcos.length > 0 ? (
                    <>
                        <p className="text-center font-bold">
                            Certificados de Vistoria de Conclusão de Obras –
                            CVCO
                        </p>
                        <div>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Número</th>
                                        <th>Tipo Vistoria</th>
                                        <th>Área</th>
                                        <th>Área Concluída</th>
                                        <th>Data Conclusão</th>
                                        <th>Ano</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cvcos.map((cvco) => (
                                        <tr key={cvco.id}>
                                            <td>{cvco.numero}</td>
                                            <td>{cvco.tipovistoria}</td>
                                            <td>{cvco.area}</td>
                                            <td>{cvco.areaconcluida}</td>
                                            <td>{cvco.dataconclusao}</td>
                                            <td>{cvco.ano}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                ) : (
                    <div>
                        <p className="text-center">
                            Não foram encontrados Certificados de Vistoria de
                            Conclusão de Obras – CVCO para o imóvel. Em caso de
                            dúvidas, entrar em contato com a Secretaria
                            Municipal de Urbanismo
                        </p>
                    </div>
                )}
            </Row>
            <DivisorPeB />
        </>
    );
};
